import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
//import { SpecialityTypes } from '../../config/RayCodes';
import { CountryCode } from '../../config';
import { SiteSurveyAction, ErrorCodeAction, ProductAction } from '../../actions';
import { RayForm, RayFormValidation } from '../common';
import { useTranslation } from 'react-i18next';
import { Translate as t } from '../../config/Translate';

const SurveyStep0 = ({ info, Create, Update, isSummary = false, gostep, user }) => {
	//const [ t, i18n ] = useTranslation();
	const [errors, setErrors] = useState([]);
	const [isAddProcess, setIsAddProcess] = useState(false);
	const [siteSurvey, setSiteSurvey] = useState(info ? info : { siteSurveyStep: 2 });

	const SpecialityTypes = [
		{ code: "GP", title: t('user.type.generalPractitioner') },
		{ code: "Pros", title: t('user.specialty.prosthodontist') },
		{ code: "Endo", title: t('user.specialty.endodontist') },
		{ code: "Perio", title: t('user.specialty.periodontist') },
		{ code: "Ortho", title: t('user.specialty.orthodontist') },
		{ code: "Ped", title: t('user.specialty.pediatricDentist') },
		{ code: "Oral", title: t('user.specialty.oralMaxillofacialSurgeon') },
		{ code: "Public", title: t('user.specialty.publicHealthDentist') },
		{ code: "Rad", title: t('user.specialty.radiologist') },
		{ code: "Other", title: t('common.label.other') },
	]

	useEffect(() => {
		setSiteSurvey(info);
		setSiteSurvey({ ...siteSurvey, ["siteCountry"]: info.siteCountry ? info.siteCountry : user.companyInfo.country });
	}, [info]);

	useEffect(() => {
		if (gostep) {
			if (gostep.curStep == 1) {
				const errValidate = RayFormValidation(form_controls, siteSurvey);
				if (errValidate.length > 0) {
					setErrors(errValidate);
				} else {
					setIsAddProcess(true);
					Update(siteSurvey._id, { ...siteSurvey, siteSurveyStep: gostep.goStepNo });
				}
			}
		}
	}, [gostep])

	const handleChangeData = (e) => {
		const { name, value } = e.target;
		setSiteSurvey({ ...siteSurvey, [name]: value });
	};

	const form_controls = [
		{
			title: t('site.field.practice'), items: [
				{ type: "input", name: "siteSitename", label: t('site.field.siteName'), val: siteSurvey.siteSitename, required: true, isEditable: !isSummary },
				{ type: "select2", name: "siteSpeciality", label: t('site.field.specialty'), val: siteSurvey.siteSpeciality, list: SpecialityTypes, isEditable: !isSummary }
			]
		},
		{
			title: "", items: [
				{ type: "select2", name: "siteCountry", label: t('common.field.country'), val: !siteSurvey.siteCountry ? user.companyInfo.country : siteSurvey.siteCountry, list: CountryCode, isEditable: !isSummary, isCounrty: true },
				{ type: "input", name: "siteAddress", label: t('common.field.fullAddress'), val: siteSurvey.siteAddress, isEditable: !isSummary },
			]
		},
		{
			title: "", items: [
				{ type: "tel", name: "siteZipcode", label: t('common.field.zipCode'), val: siteSurvey.siteZipcode, isEditable: !isSummary },
				{ type: "input", name: "siteWebsite", label: t('common.field.website'), val: siteSurvey.siteWebsite, isEditable: !isSummary }
			]
		},
		{
			title: t('common.label.customer'), items: [
				{ type: "input", name: "customerFirstName", label: t('common.message.required.firstName'), val: siteSurvey.customerFirstName, required: true, isEditable: !isSummary },
				{ type: "input", name: "customerLastName", label: t('common.message.validation.lastNameRequired'), val: siteSurvey.customerLastName, required: true, isEditable: !isSummary }
			]
		},
		{
			title: "", items: [
				{ type: "email", name: "customerEmail", label: t('common.field.email'), val: siteSurvey.customerEmail, isEditable: !isSummary },
				{ type: "input", name: "customerHp", label: t('common.field.mobile'), val: siteSurvey.customerHp, isEditable: !isSummary }
			]
		},
	];

	const validAdd = () => {
		const errValidate = RayFormValidation(form_controls, siteSurvey);
		if (errValidate.length > 0) {
			setErrors(errValidate);
		} else {
			setIsAddProcess(true);
			if (siteSurvey._id) {
				Update(siteSurvey._id, { ...siteSurvey, siteSurveyStep: 2 });
			} else {
				Create({ ...siteSurvey, siteSurveyStep: 2 });
			}
		}
	};

	return (
		<>
			<RayForm
				controls={form_controls}
				showAllFields={true}
				isForm={!isSummary}
				isSummary={isSummary}
				handleChangeData={handleChangeData}
				errors={errors}
			/>
			{!isSummary &&
				<div className="section">
					<div className="mb-2 clearfix">
						<button className="btn btn-primary btn-block btn-lg" onClick={() => validAdd()}>{t('common.button.next')}</button>
					</div>
				</div>
			}
		</>
	);
};

const mapState = (state) => {
	const user = state.AuthReducer.user;
	return { user };
};

const mapDispatch = (dispatch) => ({
	Create: (data) => dispatch(SiteSurveyAction.CreateSiteSurvey(data)),
	Update: (_id, data) => dispatch(SiteSurveyAction.UpdateSiteSurvey(_id, data)),
});

export default connect(mapState, mapDispatch)(SurveyStep0);